
            import "data:text/css,.m-content-b2e4ac193e%7Btext-align:center;position:fixed;bottom:0;right:0;height:auto;margin-bottom:3em;margin-right:3em%7D.m-title-b2e4ac193e%7Bfont-size:2em;color:#72727d%7D.m-value-b2e4ac193e%7Bfont-size:2em%7D";
            const result = {"content":"m-content-b2e4ac193e","title":"m-title-b2e4ac193e","value":"m-value-b2e4ac193e"};
            export default result;
          